import { render, staticRenderFns } from "./BuscaLocacoes.vue?vue&type=template&id=fe857206&"
import script from "./BuscaLocacoes.vue?vue&type=script&lang=js&"
export * from "./BuscaLocacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports